import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BASE_URL } from './utils/api';

import Layout from "./Layout";
import Home from "./pages/Home/Home";
import Tags from "./pages/Tags/Tags";
import AskQuestion from "./pages/AskQuestion/AskQuestion";
import PasswordLogin from "./pages/PasswordLogin/PasswordLogin";
import Register from "./pages/Register/Register";
import EmailVerify from "./pages/EmailVerify/EmailVerify";
import OTPVerify from "./pages/OTPVerify/OTPVerify";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import Profile from "./pages/Profile/Profile";
import MySaveDraft from "./pages/MySaveDraft/MySaveDraft";
import QuestionDetail from './pages/QuestionDetail/QuestionDetail';
import MyQuestions from './pages/MyQuestions/MyQuestions';
import MyReplies from './pages/MyReplies/MyReplies';
import SearchResults from "./pages/SearchResults/SearchResults";
import TagQuestions from "./pages/Tags/TagQuestions"; // Example fix
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";

// React Router configuration
const router = createBrowserRouter([
  {
    path: "/",
    element: <EmailVerify />,
  },
  {
    path: "/login",
    element: <PasswordLogin />,
  },
  {
    path: "/verify-otp",
    element: <OTPVerify />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/dashboard",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "tags",
        element: <Tags />,
      },
      {
        path: "tags/:tagName", // ✅ Added dynamic tag route
        element: <TagQuestions />,
      },
      {
        path: "ask-question",
        element: <AskQuestion />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "saved-draft",
        element: <MySaveDraft />,
      },
      {
        path: 'questions/:id',  
        element: <QuestionDetail />,
      },
      {
        path: 'my-questions', 
        element: <MyQuestions />,
      },
      {
        path: 'my-replies', 
        element: <MyReplies />,
      },
      {
        path:'search',
        element:<SearchResults />,
      },
    ],
  },
  {
    path: "*",
    element: (
      <div style={{ padding: 20 }}>
        <h2>404 - Page Not Found</h2>
      </div>
    ),
  },
]);

// Mounting the app
ReactDOM.createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);